import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabaseClient';

export interface CareRequest {
  id: number;
  receipt_time: string;
  receipt_number: string;
  caregiver_reg_number: string;
  caregiver_name: string;
  caregiver_phone: string;
  caregiver_birth: string;
  caregiver_gender: string;
  caregiver_address: string;
  caregiver_ssn: string | null;
  patient_name: string | null;
  patient_phone: string | null;
  patient_birth: string | null;
  patient_gender: string | null;
  patient_address: string | null;
  insurance_company: string | null;
  agent_phone: string | null;
  status: '접수' | '진행중' | '완료';
  is_duplicate: boolean;
  admin_code: string | null;
  created_at: string;
  updated_at: string;
}

export type StatusFilter = '전체' | '접수' | '진행중' | '완료';

export function useCareRequests() {
  const [data, setData] = useState<CareRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    const { data: rows, error: err } = await supabase
      .from('care_requests')
      .select('*')
      .order('receipt_time', { ascending: false });

    if (err) {
      setError(err.message);
    } else {
      setData(rows as CareRequest[]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const updateStatus = async (id: number, status: CareRequest['status']) => {
    const { error: err } = await supabase
      .from('care_requests')
      .update({ status, updated_at: new Date().toISOString() })
      .eq('id', id);

    if (err) return false;
    setData((prev) =>
      prev.map((item) => (item.id === id ? { ...item, status } : item))
    );
    return true;
  };

  return { data, loading, error, refetch: fetch, updateStatus };
}
